import React, { useEffect, useState } from "react";
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import { Box, Dialog, DialogTitle, Typography, DialogContent, List, Button, ListItem, ListItemText, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CoordsModal from './CoordsModal';
import FindUserMap from './FindUserMap';

const Location = ({ onBackClick, userId }) => {
    const [deliveryPoints, setDeliveryPoints] = useState([]);

    const [modalOpen, setModalOpen] = useState(false);
    const [showMapUserCard, setShowMapUserCard] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [showMessageList, setShowMessageList] = useState(false);

    const handleFindUserMapClick = () => {
        setShowMapUserCard(true);
    };

    const handleCloseFindUserMapCard = () => {
        setShowMapUserCard(false);
    };

    const handleSaveCoords = async (lat, lng) => {
        const token = localStorage.getItem('token');
        try {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/delivery_point/update_coords`, {
            id: selectedId,
            latitude: lat,
            longitude: lng,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setModalOpen(false);
          setDeliveryPoints((prev) =>
            prev.map((dp) =>
              dp.id === selectedId ? { ...dp, latitude: lat, longitude: lng } : dp
            )
          );
        } catch (err) {
          console.error('Error al guardar coordenadas:', err);
          alert("Error al guardar las coordenadas.");
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('token');
      
        // Función que hace la llamada y actualiza el estado
        const fetchDeliveryPoints = () => {
          axios.get(`${process.env.REACT_APP_API_URL}/api/delivery_points/admin`, {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(response => {
            setDeliveryPoints(response.data);
          })
          .catch(error => {
            console.error('Error fetching delivery points:', error);
          });
        };
      
        // Llamada inicial
        fetchDeliveryPoints();
      
        // Intervalo cada 4 segundos (4000 ms)
        const intervalId = setInterval(fetchDeliveryPoints, 4000);
      
        // Cleanup: cuando el componente se desmonte, limpiamos el intervalo
        return () => clearInterval(intervalId);
      }, []);



    const handleWhatsappWithUpdate = async (dp) => {
    // 1. if not yet sent, call update endpoint
        if (!dp.ubicacion_enviado) {
        try {
            await axios.post(
            `${process.env.REACT_APP_API_URL}/api/update_ubicacion_enviado`,
            { id: dp.id }
            );
            // update local state so UI turns green immediately
            setDeliveryPoints(prev =>
            prev.map(p =>
                p.id === dp.id ? { ...p, ubicacion_enviado: true } : p
            )
            );
        } catch (err) {
            console.error('Failed to mark ubicacion_enviado:', err);
            // optionally alert the user here
        }
        }

        // 2. now open WhatsApp
        const message = encodeURIComponent("Por favor envíe su ubicación lo antes posible.");
        window.open(`https://wa.me/+51${dp.recipient_phone}?text=${message}`, '_blank');
    };

    const handleWhatsappUserClick = (phone, recipientName) => {
        const message = encodeURIComponent(`El cliente ${recipientName} aún no ha enviado la ubicación para la entrega, por favor contáctelo para obtener la ubicación.`);
        window.open(`https://wa.me/+51${phone}?text=${message}`, '_blank');
    };

    return (
        <Box p={2} style={{ height: '750px', overflowY: 'auto' }}>
    {/* Back Arrow */}
    <IconButton onClick={onBackClick} style={{ marginBottom: '20px' }}>
        <ArrowBackIcon />
    </IconButton>
    {/* Title */}
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 2 // matches your previous gutterBottom
      }}
    >
      <Typography 
        variant="h6" 
        sx={{ color: 'black', flexGrow: 1 }}
      >
        Ubicaciones Faltantes
      </Typography>
      <IconButton
        onClick={() => setShowMessageList(true)}
        aria-label="Ver Mensajes"
        sx={{ ml: 1 }}  // small left margin so it’s not jammed into the text
      >
        <WhatsAppIcon />
      </IconButton>
    </Box>
    {/* Table to display delivery points */}
    <Table stickyHeader>
        <TableHead>
            <TableRow>
                <TableCell>Delivery ID</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Teléfono</TableCell>
                <TableCell>Dirección</TableCell>
                <TableCell>Distrito</TableCell>
                <TableCell>Producto</TableCell>
                <TableCell>Notas</TableCell>
                <TableCell>Usuario</TableCell>
                <TableCell>Enlace</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {deliveryPoints
                .filter(dp => !dp.latitude || !dp.longitude)  // Only show items without latitude and longitude
                .map((deliveryPoint) => (
                    <TableRow key={deliveryPoint.id}>
                        <TableCell>{deliveryPoint.id}</TableCell>
                        <TableCell>{deliveryPoint.recipient_name}</TableCell>
                        <TableCell>
                            {deliveryPoint.recipient_phone}
                            <IconButton onClick={() => handleWhatsappWithUpdate(deliveryPoint)}>
                                <WhatsAppIcon style={{
                                        color: deliveryPoint.ubicacion_enviado ? 'green' : 'gray'
                                    }} 
                                />
                            </IconButton>
                            <IconButton size="small" onClick={() => {
                                setSelectedId(deliveryPoint.id);
                                setModalOpen(true);
                                }}>
                                <LocationOffIcon />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            {deliveryPoint.address}
                            <IconButton size="small" onClick={() => {
                                setSelectedId(deliveryPoint.id);
                                handleFindUserMapClick();
                                }}>
                                <LocationOffIcon />
                            </IconButton>
                        </TableCell>
                        <TableCell>{deliveryPoint.district}</TableCell>
                        <TableCell>{deliveryPoint.product}</TableCell>
                        <TableCell>
                                                    {deliveryPoint.notes}
                                                </TableCell>
                        <TableCell>
                            {deliveryPoint.user_name}
                            <IconButton onClick={() => handleWhatsappUserClick(deliveryPoint.user_phone, deliveryPoint.recipient_name)}>
                                <WhatsAppIcon style={{ color: 'green' }} />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                                                    www.fastmaxlima.pe/#/{deliveryPoint.id}
                                                </TableCell>
                    </TableRow>
                ))}
        </TableBody>
    </Table>
    {modalOpen && 
            <CoordsModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            onSave={handleSaveCoords}
          />
    }
    {showMapUserCard && (
        <FindUserMap onClose={handleCloseFindUserMapCard} deliveryId={selectedId} />
    )}
    <Dialog
        open={showMessageList}
        onClose={() => setShowMessageList(false)}
        fullWidth
        maxWidth="sm"
        >
        <DialogTitle>Enviar WhatsApp</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: 400, p: 0 }}>
            <List>
            {deliveryPoints.map(dp => (
                <ListItem 
                key={dp.id} 
                divider 
                secondaryAction={
                    <IconButton
                    edge="end"
                    onClick={() => handleWhatsappWithUpdate(dp)}
                    sx={{ color: dp.ubicacion_enviado ? 'green' : 'gray' }}
                    >
                    <WhatsAppIcon />
                    </IconButton>
                }
                >
                <ListItemText
                    primary={`ID: ${dp.id} ${dp.user_name} ${dp.recipient_phone}`} 
                    secondary={dp.recipient_name} 
                />
                </ListItem>
            ))}
            </List>
        </DialogContent>
    </Dialog>
</Box>

    );
};

export default Location;
